// @flow
import { TravelsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    travel: {},
    listaTravels: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type TravelsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { travel?: {} | null, listaTravels?: [] | null, loading?: boolean, +value ?: boolean };

const Travels = (state: State = INIT_STATE, action: TravelsAction): any => {
    // console.log(action);
    switch (action.type) {
        case TravelsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TravelsActionTypes.GET_TRAVEL: {
                    return {
                        ...state,
                        travel: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TravelsActionTypes.LIST_TRAVELS: {
                    return {
                        ...state,
                        listaTravels: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case TravelsActionTypes.ADD_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case TravelsActionTypes.UPDATE_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case TravelsActionTypes.DELETE_TRAVEL: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TravelsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TravelsActionTypes.GET_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        travel: {},
                        loading: false,
                    };
                }
                case TravelsActionTypes.LIST_TRAVELS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaTravels: [],
                        loading: false,
                    };
                }
                case TravelsActionTypes.ADD_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case TravelsActionTypes.UPDATE_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case TravelsActionTypes.DELETE_TRAVEL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TravelsActionTypes.GET_TRAVEL:
            return { ...state, error: false, loading: true };
        case TravelsActionTypes.LIST_TRAVELS:
            return { ...state, error: false, loading: true };
        case TravelsActionTypes.ADD_TRAVEL:
            return { ...state, error: false, loadingForm: true };
        case TravelsActionTypes.UPDATE_TRAVEL:
            return { ...state, error: false, loadingForm: true };
        case TravelsActionTypes.DELETE_TRAVEL:
            return { ...state, error: false, loading: true };
        case TravelsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                travel: {},
                listaTravels: [],
                formSubmited: false
            };
        case TravelsActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Travels;
